import React, { useState } from 'react';
import { Button } from '../Button';
import { BuildingStorefrontIcon, SaveIcon, PlusIcon, DeleteIcon } from './DashboardIcons';


const initialContent = {
    lead: `Abre tu propio negocio de defensa legal con el respaldo de una marca líder en Europa. Te ofrecemos un modelo de negocio probado, rentable y con un alto impacto social.`,
    profilePoints: [
        `Profesionales con formación legal (abogados, graduados sociales, etc.).`,
        `Emprendedores con vocación comercial y de gestión.`,
        `Personas con un fuerte compromiso con la atención al cliente y la ética profesional.`,
        `No se requiere experiencia previa en el sector, ¡nosotros te formamos!`,
    ]
};

export const FranchisesView: React.FC = () => {
    const [lead, setLead] = useState(initialContent.lead);
    const [profilePoints, setProfilePoints] = useState(initialContent.profilePoints);

    const handlePointChange = (index: number, value: string) => {
        const newPoints = [...profilePoints];
        newPoints[index] = value;
        setProfilePoints(newPoints);
    };

    const handleAddPoint = () => {
        setProfilePoints([...profilePoints, '']);
    };
    
    const handleRemovePoint = (index: number) => {
        setProfilePoints(profilePoints.filter((_, i) => i !== index));
    };

    const handleSaveChanges = () => {
        console.log("Saving franchise content:", { lead, profilePoints });
        alert("Contenido de Franquicias guardado.");
    };

    return (
        <div className="p-8 bg-white rounded-lg shadow-sm">
            <h1 className="text-2xl font-bold text-gray-800 flex items-center mb-6">
                <BuildingStorefrontIcon /><span className="ml-2">Gestión de Página de Franquicias</span>
            </h1>

            <div className="space-y-6">
                <div>
                    <label htmlFor="lead-text" className="block text-lg font-semibold text-gray-700 mb-2">Texto de Introducción</label>
                    <textarea 
                        id="lead-text"
                        value={lead}
                        onChange={(e) => setLead(e.target.value)}
                        className="w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                        rows={4}
                    />
                </div>
                
                <div>
                    <div className="flex justify-between items-center mb-2">
                        <label className="block text-lg font-semibold text-gray-700">Puntos Clave del "Perfil Ideal"</label>
                        <Button onClick={handleAddPoint} size="small" variant="primary" className="bg-blue-600 hover:bg-blue-700 text-white">
                            <span className="flex items-center"><PlusIcon /></span>
                        </Button>
                    </div>
                     <div className="space-y-3">
                        {profilePoints.map((point, index) => (
                            <div key={index} className="flex items-center gap-3">
                                <input 
                                    type="text"
                                    value={point}
                                    onChange={(e) => handlePointChange(index, e.target.value)}
                                    className="w-full p-2 border border-gray-300 rounded-md shadow-sm"
                                    placeholder={`Punto ${index + 1}`}
                                />
                                <Button onClick={() => handleRemovePoint(index)} size="small" variant="outline" className="border-red-500 text-red-500 hover:bg-red-50 p-2">
                                    <DeleteIcon />
                                </Button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="mt-8 pt-6 border-t border-gray-200 flex justify-end">
                <Button onClick={handleSaveChanges} variant="success" size="large">
                    <span className="flex items-center"><SaveIcon /><span className="ml-2">Guardar Contenido</span></span>
                </Button>
            </div>
        </div>
    );
};